import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Zoom } from '@wds/motion';
import { Button } from '@wds/button';

import STRINGS from '../constants';

const LockedOut = () => {
	return (
		<Box
			id='mfa-card-1'
			display='flex'
			justifyContent='center'
			alignItems='center'
			role='main'
			style={{ boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}>
			<Box
				display='flex'
				justifyContent='space-around'
				flexDirection='column'
			>
				<Zoom in>
					<Box>
						<Box
							style={{
								width: '400px',
								backgroundColor: 'white',
								margin: 'auto',
								minHeight: 320,
							}}
							role='region'
							py={4}
						>
							<Box
								display='flex'
								justifyContent='center'
								alignItems='center'
								style={{ width: '400px' }}
							>
								<img
									className='sma-logo-powered'
									src='/media/img/smapply/apply.svg'
									alt='SurveyMonkey Apply logo'
									style={{ maxWidth: '150px', margin: 25 }}
								/>
							</Box>
							<Zoom in>
								<Box
									style={{
										minHeight: 320,
										position: 'static',
									}}
								>
								<Box
									display='flex'
									flexDirection='column'
									style={{ position: 'static', width: '100%' }}
								>
									<Box
										display='flex'
										flexDirection='column'
										justifyContent='center'
										pt={4}
										pb={2}
									>
										<Box display='flex' justifyContent='center' flexDirection='column' px='6' gap={5}>
											<Typography variant='sectionTitle' weight='medium' align='center'>
												{STRINGS.lockedOutTitle}
											</Typography>
											<Typography component='p' variant='bodySm'>
												{STRINGS.lockedOutMessage}
											</Typography>
											<Typography component='p' variant='bodySm'>
												{STRINGS.lockedOutSupport}
												{' '}
												<Typography
													component='a'
													variant='link'
													href={reverse('helpdesk')}
													target='_blank'
													rel='noopener noreferrer'
												>
													{STRINGS.lockedOutSupportLink}
												</Typography>
											</Typography>
											<Button variant="primary" href='/'>
												{STRINGS.returnToHomepage}
											</Button>
										</Box>
									</Box>
								</Box>
								</Box>
							</Zoom>
						</Box>
					</Box>
				</Zoom>
			</Box>
		</Box>
	);
};

export default LockedOut;
